export default {
  namespaced: true,
  state: {
    previousRoute: '',
  },
  mutations: {
    SET_PREVIOUS_ROUTE(state, route) {
      state.previousRoute = route
    },
  },
  actions: {
    setPreviousRoute({ commit }, route) {
      commit('SET_PREVIOUS_ROUTE', route)
    },
  },
}
